import { create } from 'zustand';

import { getScanCounters, putScanCounters } from '../services/api/scanCountersApi';

let inFlight = null;
let epoch = 0; // bumped by reset(): a response from before a sign-out must not refill the store

/**
 * Scan & Share counters (SSC) - ONE shared, single-flight copy for the settings table, the ABHA
 * tab cards and the waiting-list chips. `fetchCounters` is idempotent: it does nothing once loaded,
 * shares the in-flight promise, and does not auto-retry a failure (pass `force` for an explicit retry).
 */
const useScanCountersStore = create((set, get) => ({
  hipId: null,
  shareBaseUrl: null,
  counters: [],
  loaded: false,
  failed: false,

  fetchCounters: ({ force = false } = {}) => {
    const { loaded, failed } = get();
    if (inFlight) return inFlight;
    if (!force && (loaded || failed)) return Promise.resolve();
    const mine = epoch;
    const p = getScanCounters()
      .then((data) => { if (mine === epoch) set({ ...data, loaded: true, failed: false }); })
      .catch(() => { if (mine === epoch) set({ failed: true }); })
      .finally(() => { if (mine === epoch) inFlight = null; });
    inFlight = p;
    return p;
  },

  /** Sign-out: clear org data and orphan any request still in flight. */
  reset: () => {
    epoch += 1;
    inFlight = null;
    set({ hipId: null, shareBaseUrl: null, counters: [], loaded: false, failed: false });
  },

  /** Admin - replace the whole list; the response is the new source of truth. */
  saveCounters: async (counters) => {
    const mine = epoch;
    const data = await putScanCounters(counters);
    if (mine !== epoch) return;
    set({ ...data, loaded: true, failed: false });
  },
}));

export default useScanCountersStore;
